<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <h4 class="card-title">Създаване на конфигурация за автоматично създаване на рецепти</h4>
                    </div>

                </div>

                <div class="row" style="padding-top: 15px;">
                    <div class="col-12">

                        <div *ngIf="!showPreview" class="config-form">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="font-weight-bold">Начална дата</label>
                                        <p>Моля, изберете от календара начална дата</p>

                                        <app-datepicker #datepicker [date]="dateFrom"
                                                        (dateChanged)="onDateFromPickerChanged($event)"></app-datepicker>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="font-weight-bold">Крайна дата</label>
                                        <p>Моля, изберете от календара крайна дата</p>

                                        <app-datepicker #datepicker [date]="dateTo"
                                                        (dateChanged)="onDateToPickerChanged($event)"></app-datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" style="padding-top: 15px; border-top:1px solid #ccc;">
                                <label class="font-weight-bold">Рецепти</label>
                                <p>Моля, по една или повече рецепти за всеки вид хранене</p>

                                <ng-container *ngIf="meals && recipesByMeal">
                                    <div class="row">
                                        <div
                                                *ngFor="let meal of meals;"
                                                class="col-md-12 recipes-group">
                                            <div class="row">

                                                <div class="col-md-6">
                                                    <h3>{{ meal.title }}</h3>

                                                    <div class="search-bar">
                                                        <input
                                                                placeholder="Търсене в {{ meal.title }}"
                                                                class="form-control"
                                                                (keyup)="onRecipeSearch($event, meal.id)"
                                                                type="text"/>
                                                    </div>

                                                    <ul class="recipes-list">
                                                        <li *ngFor="let recipe of sortRecipes(recipesByMeal[meal.id])">
                                                            <input (change)="selectRecipe(meal.id, recipe.id, recipe)"
                                                                   type="checkbox"/>
                                                            <span>{{ recipe.title }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-md-6">
                                                    <h3>
                                                        Избрани - {{ meal.title }}

                                                        <ng-container
                                                                *ngIf="selectedRecipesByMeal[meal.id] && selectedRecipesByMeal[meal.id].length > 0">
                                                            ({{ selectedRecipesByMeal[meal.id].length }})
                                                        </ng-container>
                                                    </h3>

                                                    <div class="search-bar">
                                                        <input
                                                                (keyup)="onSelectedRecipeSearch($event, meal.id)"
                                                                placeholder="Търсене в избрани - {{ meal.title }}"
                                                                class="form-control"
                                                                type="text"/>
                                                    </div>

                                                    <ul class="recipes-list">
                                                        <li *ngFor="let recipe of sortRecipes(selectedRecipesByMeal[meal.id])">
                                                            <input (change)="unSelectRecipe(meal.id, recipe.id, recipe)"
                                                                   checked
                                                                   type="checkbox"/>
                                                            <span>{{ recipe.title }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <div class="form-group">
                                <label class="font-weight-bold">Активен</label>
                                <app-toggle-switch [toggled]="is_active"
                                                   (onChange)="onIsActiveChange($event)"></app-toggle-switch>
                            </div>

                            <button
                                    (click)="save()"
                                    class="btn btn-success btn-icon-text">
                                <i class="ti-save btn-icon-prepend"></i>
                                Запази
                            </button>
                        </div>

                        <div *ngIf="showPreview" class="preview">
                            <div class="form-group">
                                <label class="font-weight-bold">Начална дата</label>
                                <p>{{ formatDate(dateFrom) }}</p>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold">Крайна дата</label>
                                <p>{{ formatDate(dateTo) }}</p>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold">Избрани Рецепти</label>

                                <ul class="selected-recipes">
                                    <li *ngFor="let meal of meals">
                                        <h3>{{ meal.title }}</h3>
                                        <ul>
                                            <li *ngFor="let recipe of selectedRecipesByMeal[meal.id]">
                                                {{ recipe.title }}
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                            <div class="form-group">
                                <label class="font-weight-bold">Активен</label>
                                <app-toggle-switch [toggled]="is_active"
                                                   (onChange)="onIsActiveChange($event)"></app-toggle-switch>
                            </div>

                            <button
                                    (click)="editConfig()"
                                    class="edit-config-btn btn btn-secondary btn-icon-text">
                                <i class="ti-pencil btn-icon-prepend"></i>
                                Редактирай
                            </button>
                            <button
                                    (click)="createConfig()"
                                    class="btn btn-success btn-icon-text">
                                <i class="ti-save btn-icon-prepend"></i>
                                Потвърди и създай конфигурация
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
